import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export const beatStyles = stylex.create({
  stack: { display: "flex", flexDirection: "column", gap: spacing.space16 },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space16,
    minWidth: 0,
    padding: 0,
    margin: 0,
    listStyle: "none",
  },
  beat: { display: "flex", alignItems: "flex-start", gap: spacing.space16 },
  number: {
    width: 20,
    flexShrink: 0,
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
    lineHeight: 1.5,
    color: colors.muted,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flex: 1,
    gap: spacing.space4,
  },
  title: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: fontSizes.body,
    lineHeight: 1.3,
    fontWeight: 600,
    color: colors.foreground,
  },
  body: {
    margin: 0,
    fontFamily: fonts.sans,
    fontSize: fontSizes.label,
    lineHeight: 1.5,
    color: colors.secondary,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: spacing.space8,
  },
  caption: {
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
    lineHeight: 1.5,
    color: colors.muted,
  },
});
